import React, { useContext, useMemo, useState, useEffect } from 'react';
import Select from 'react-select';
// import { Select } from 'antd';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { FormContext } from '../../metadata/MDForm';

export function InterestType({ defaultValue, onChange }) {
  const { productSetup } = useContext(ProductInfoContext);
  const { getValueByAttr, setValueByAttr } = useContext(FormContext);
  const interestTypes =
    productSetup.productAdditionalInterests.productAdditionalInterest;
  const interestTypeValue = getValueByAttr('InterestType');

  const [selectedOption, setSelectedOption] = useState(
    interestTypeValue
      ? {
          value: interestTypeValue,
          label: interestTypeValue,
        }
      : defaultValue
  );

  const handleChange = (selected) => {
    setValueByAttr('InterestType', selected.value);
    setSelectedOption(selected);
  };

  const options = interestTypes.map((interest) => {
    return {
      value: interest.typeCd,
      label: interest.typeCd,
    };
  });

  return (
    <Select
      aria-label="Select"
      styles={customStyles}
      title="Select"
      openMenuOnFocus
      placeholder={null}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      components={{
        IndicatorSeparator: () => null,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        zIndex: 3,
        colors: {
          ...theme.colors,
          primary25: 'rgb(0, 115, 157, 0.1)',
          primary: 'rgba(0, 115, 157, 0.5)',
          neutral30: 'rgba(0, 115, 157, 0.5)',
        },
      })}
    />
  );
}

const customStyles = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};
